module.exports = __webpack_public_path__ + "img/about-right-shape.21ab67da.png";